<template>
  <div>
    <div class="header mt-3 mt-md-0 edit-page-header">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="header-pretitle">
              공지 사항
            </h6>
            <h1 class="header-title">
              FIFL 공지 리스트
            </h1>
          </div>
        </div>
      </div>
    </div>

    <el-table
      :data="noticeCurrentPageList"
      style="width: 100%"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      row-class-name="fifl-table-row"
      cell-class-name="fifl-main-table-cell"
      @row-click="handleClickNoticeRow"
    >
      <el-table-column
        prop="index"
        label="번호"
        label-class-name="table__index"
        :width="tableColWidth.index"
      />
      <el-table-column
        prop="title"
        label="제목"
        :width="tableColWidth.title"
      >
        <template slot-scope="scope">
          <router-link
            :to="`/fiflbox-notices/${scope.row.id}`"
          >
            {{ scope.row.title }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="published"
        label="일시"
        :width="tableColWidth.published"
      >
        <template slot-scope="scope">
          {{ format(scope.row.published, 'YYYY.MM.DD') }}
        </template>
      </el-table-column>
      <div
        slot="empty"
        class="table-empty-container"
      >
        <warning-message
          v-show="isContentLoaded"
          message="등록된 공지가 없습니다."
        />
      </div>
    </el-table>

    <div style="margin-top: 25px; text-align: center;">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="notices.length"
      />
    </div>
  </div>
</template>

<script>
import EditPageHeader from "../../components/EditPageHeader";
import WarningMessage from "../../components/element-ui/WarningMessage";
import resizePageMixin from "../../mixins/resizePageMixin";
import { format } from "date-fns";
import { computedGetters } from "../../utils/vuex-helper";

const RESPONSIVE_TABLE_WIDTH = {
	mobile: {
		index: 50,
		title: null,
		published: 140,
	},
	desktop: {
		index: 95,
		title: null,
		published: 162,
	},
};

export default {
	name: "FiflNotice",
	components: { WarningMessage, EditPageHeader },
	mixins: [resizePageMixin],
	data() {
		return {
			pageSize: 10,
			currentPage: 1,

			notices: [],
			tableColWidth: RESPONSIVE_TABLE_WIDTH["desktop"],
			isContentLoaded: false,
		};
	},
	computed: {
		...computedGetters(["alerts"]),
		noticeCurrentPageList() {
			let startId = (this.currentPage - 1) * this.pageSize;
			let endId = this.currentPage * this.pageSize;

			return this.notices.slice(startId, endId);
		},
	},
	created() {
		this.syncNotices();
	},
	methods: {
		format,
		handleClickNoticeRow(row, event, column) {
			this.$router.push(`/fiflbox-notices/${row.id}`).catch(()=>{});
		},
		handleClickSortByDate({ column, prop, order }) {
			let orders = order === "ascending" ? "asc" : "desc";
			this.notices = _.orderBy(this.notices, ["created"], [orders]);
		},
		onResize() {
			this.tableColWidth =
				RESPONSIVE_TABLE_WIDTH[window.innerWidth < 768 ? "mobile" : "desktop"];
		},
		async syncNotices() {
			await this.$store.dispatch("syncAlerts");
			let noticeLength = this.alerts.length;

			this.notices = this.alerts.map((notice, index) => {
				return {
					...notice,
					index: noticeLength - index,
				};
			});
			this.isContentLoaded = true;
		},
	},
};
</script>
